import React from 'react';
import PropTypes from 'prop-types';
import './CssLearn.scss';

const CssLearn = () => {
  return (
    <div className="CssLearn">
      <div className="main-right-side-section">
        <div className="css-inner-section">
          <p className='font-Poppins text-6xl font-bold text-Primary'>This is CSS</p>
        </div>
      </div>
    </div>
  );
}

CssLearn.propTypes = {};

CssLearn.defaultProps = {};

export default CssLearn;
